import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import Notiflix from "notiflix";

import {
  Input,
  Row,
  Card,
  Form,
  Statistic,
  Col,
  Divider,
  Spin,
  Table,
  Typography,
  Layout,
  Collapse,
  Select,
  DatePicker,
  InputNumber,
  Button,
  Modal,
  Tooltip,
  List,
} from "antd";
import {
  PlusOutlined,
  DeleteOutlined,
  DownloadOutlined,
  PlusCircleOutlined,
  LeftOutlined,
} from "@ant-design/icons";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import CustomButton from "../../../components/custom/CustomButton";
import MainLayout from "../../../components/layouts/MainLayout";
import TopContent from "../../../components/layouts/TopContent";
import { apiConfig, labelConfig, staticConfig } from "../systemAdmin.config";
import dayjs from "dayjs";
import { accountStatus } from "../../../components/facilities/AccountFacility";
import styles from "../../../assets/styles/styles";

const { TextArea } = Input;
const { Content } = Layout;
const { Panel } = Collapse;

const DetailTillConfiguration = (props) => {
  //DECLARED VARIABLES
  const { userData } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const [useForm] = Form.useForm();
  const { state } = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const { Text, Title } = Typography;
  // DECLARED VARIABLES FOR CHARRGES FORM
  const [officeData, setOfficeData] = useState([]);
  const [configureLimitTableSource, setConfigurelimitTableSource] = useState(
    []
  );

  // ENDPOINT DECLARED VARIABLES
  const [formData, setFormData] = useState({
    authForm: {},
    tellerCcyRestrConfData: [],
  });

  useEffect(() => {
    getTillConfigurationId();
  }, []);

  const getTillConfigurationId = () => {
    setIsLoading(true);

    const url = apiConfig.Tellerconfig + `/${state.id}`;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        // setTemplateConfigDetail(res);
        const objDetails = res;
        // let tempOfficeData = [];

        // objDetails?.forEach((element) => {
        //   tempOfficeData.push({
        //     value: element.id,
        //     label: element.name,
        //   });
        // });
        console.log(objDetails)

        const authForm = {
          vaultId:objDetails.vaultId.id,
          description: objDetails.description,
          allowDenomTracking: objDetails.allowDenomTracking,
          printTransactionReceipt: objDetails.printTransactionReceipt,
          allowTransactionReversal: objDetails.allowTransactionReversal,
        };

        setFormData({
          authForm,
        });

        


        setConfigurelimitTableSource(objDetails.tellerCcyRestrConfData);

        setIsLoading(false);
      }
    });
  };

  console.log(formData)
  const data = {
    authForm: [
      {
        name: "Vault",
        value: formData?.authForm?.vaultId
      },
      {
        name: "Till Profile Name",
        value: formData?.authForm?.description ? "True" : "False",
      },
      {
        name: "Denomination Tracking",
        value: formData?.authForm?.allowDenomTracking ? "True" : "False",
      },
      {
        name: "Print Receipt ",
        value: formData?.authForm?.printTransactionReceipt ? "True" : "False",
      },
      {
        name: "Transaction Reversal",
        value: formData?.authForm?.allowTransactionReversal ? "True" : "False",
      },
    ],
  };

  const columns = [
    {
      key: " 1",
      title: "Currency",
      dataIndex: "currencyCode",
    },
    {
      key: " 2",
      title: "Authorization Threshold",
      dataIndex: "authThresholdAmount",
    },
    {
      key: " 3",
      title: "Daily Transaction Limit",
      dataIndex: "transactionLimit",
    },
  ];

  function onCancel() {
    navigate("/sya0600", { state: state });
  }

  return (
    <MainLayout isEnableRightSidebar={true}>
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={labelConfig.detailTillConfiguration}
        pageItems={staticConfig.detailTillConfigurationBreadcrumbItems}
      />
      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
          title={
            <Row
              style={{
                alignContent: "center",
                width: "8%",
              }}
            >
              <Button
                icon={<LeftOutlined />}
                type="text"
                style={{
                  marginTop: "auto",
                  marginBottom: "auto",
                }}
                onClick={onCancel}
              >
                <Text
                  style={{
                    marginTop: "auto",
                    marginBottom: "auto",
                    fontSize: 15,
                  }}
                >
                  Back
                </Text>
              </Button>
            </Row>
          }
        >
          <Card
            style={{
              marginBottom: "2%",
              boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
            }}
          >
            {/* AUTH FORM  */}
            <div
              style={{
                boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
                marginBottom: 25,
              }}
            >
              <Divider orientation="left" orientationMargin="0">
                {"Branch Authorization"}
              </Divider>
              {data.authForm.map((detail, index) => {
                // console.log("detail", detail);

                const { name, value } = detail;

                return (
                  <div
                    style={{
                      border: "2px solid #F5F5F5",
                      borderRadius: 15,
                      borderBottomLeftRadius: 0,
                      borderBottomRightRadius: 0,
                      borderBottomColor: "#E2E2E2",
                    }}
                    key={index}
                  >
                    <Row>
                      <Col
                        span={12}
                        style={{
                          backgroundColor: "#F5F5F5",
                          padding: 10,
                          borderRadius: 15,
                          borderTopRightRadius: 0,
                          borderBottomRightRadius: 0,
                          borderBottomLeftRadius: 0,
                        }}
                      >
                        <Text strong>{name}</Text>
                      </Col>
                      <Col
                        span={12}
                        style={{
                          padding: 10,
                        }}
                      >
                        <Text className="of-bold-disable-input">{value}</Text>
                      </Col>
                    </Row>
                  </div>
                );
              })}
            </div>

            {/* LIMITS FORM */}
            <div
              style={{
                boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
                marginBottom: 25,
              }}
            >
              <Divider orientation="left" orientationMargin="0">
                {"Branch Limits"}
              </Divider>
              <Table
                pagination={false}
                columns={columns}
                dataSource={configureLimitTableSource}
              />
            </div>
          </Card>
        </Card>
      </Spin>
    </MainLayout>
  );
};
export default DetailTillConfiguration;
